import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useEmployeesByAdmin } from '../../../hooks/admin/employees.admin';
import { useSearchParams } from 'react-router-dom';
import EmptyData from '../../../components/ui/EmptyData';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import Pagination from '../../../components/ui/Pagination';
import EmployeesListTable from '../../../components/admin/employees/EmployeesListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

export default function AdminViewEmployees() {
    const {t} = useTranslation();
     const [searchParams,setSearchParams] = useSearchParams();
    const pageQuery = Number(searchParams.get('page')) || 1;
    const {data:employees, isError , isLoading} = useEmployeesByAdmin({page:pageQuery});

    const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };


  return (
    <Layout title={t('admin_sidebar.employees')} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateAdmin]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_employee"
              buttonLinkPath={`/admin/add-employee`}
              />
            </PermissionGate>
         </div>
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {employees && 
      (
        employees.data.length===0 
        ?
        <EmptyData/>
        :
      <>
      <EmployeesListTable employees={employees.data}/>
      <Pagination
      handlePagination={handlePagination}
      totalPages={employees.totalPages}
      currentPage={pageQuery}
      />
      </>
      )
      }
    </Layout>
  )
}
